import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const FiveNavPic = Loadable({
    loader: () => import(/* webpackChunkName: "FiveNavPic" */ './fiveNavPic'),
    loading: () => <div />,
});
export const FourNavPic = Loadable({
    loader: () => import(/* webpackChunkName: "FourNavPic" */ './fourNavPic'),
    loading: () => <div />,
});
export const ThreeNavPic = Loadable({
    loader: () => import(/* webpackChunkName: "ThreeNavPic" */ './threeNavPic'),
    loading: () => <div />,
});
